import { styled } from "goober";

export const ControlButton = styled("button")`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 10px;
  border: none;
  border-radius: 9999px;
  background: var(--alpha4);
  color: var(--text-secondary);
  cursor: pointer;

  &:hover {
    background: var(--alpha8);
  }
`;
